<template>
	<div>
		<div style="padding: 20px;">
      <div style="background: #fff;border-radius: 10px;padding: 20px;">
        <div>
          数据首页
        </div>
        <div style="margin-top: 20px;display: flex;">
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              缝纫录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.fengren}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.fengren" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              包装录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.baozhuang}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.baozhuang" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              成型录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.chengxing}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.chengxing" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;display: flex;">
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              组装录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.zuzhuang}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.zuzhuang" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              焊接录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.hanjie}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.hanjie" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              涂装淋洗录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.tuzhuanglinxi}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.tuzhuanglinxi" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;display: flex;">
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              涂装凉亭录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.tuzhuangliangting}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.tuzhuangliangting" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
          <div style="width: 33%;text-align: center;">
            <div style="font-size: 30px;">
              编藤录入数据
            </div>
            <div style="font-size: 40px;font-weight: bold;">{{totalcount.bianteng}}</div>
            <div style="padding: 30px 20px;">
              <el-table :data="totalList.bianteng" element-loading-text="Loading" fit highlight-current-row border style="width: 100%">
                <el-table-column align="center" label="账号" min-width="100" prop="account"></el-table-column>
                <el-table-column align="center" label="录入数据" min-width="100" prop="entry_count"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      
    </div>

	</div>
</template>
<script>
	export default {
		data() {
			return {
				totalcount: {
          fengren: 0,
          baozhuang: 0,
          chengxing: 0,
          zuzhuang: 0,
          hanjie: 0,
          tuzhuanglinxi: 0,
          tuzhuangliangting: 0,
          bianteng: 0
        },
        totalList: {
          fengren: [],
          baozhuang: [],
          chengxing: [],
          zuzhuang: [],
          hanjie: [],
          tuzhuanglinxi: [],
          tuzhuangliangting: [],
          bianteng: [],
        },
			};
		},
		created() {
			this.gettotalcount()
      this.gettotalList()
		},
		methods: {
			gettotalcount() {
				this.$request.post('/index.php/admin/index/totalcount').then((res) => {
					this.totalcount = res.data
				})
			},
      gettotalList() {
        this.$request.post('/index.php/admin/index/totalList').then((res) => {
        	this.totalList = res.data
        })
      },

		}
	};
</script>
<style scoped="">
	
</style>
